<template>
  <!-- Card failures point the family at their email; cash / check is the one case an admin marks paid -->
  <div v-if="alerts.length > 0" class="wp-alerts">
    <div v-for="alert in alerts" :key="alert.key" class="wp-alert" :class="`wp-alert--${alert.tone}`">
      <div>
        <div class="wp-alert__title">{{ alert.title }}</div>
        <div class="wp-alert__body">{{ alert.body }}</div>
      </div>
      <button v-if="alert.invoice && isAdmin && markPaidInvoiceId !== alert.invoice.id" type="button" class="btn btn-default btn-compact" @click="markPaidInvoiceId = alert.invoice.id">
        Mark paid…
      </button>
      <div v-if="alert.invoice && markPaidInvoiceId === alert.invoice.id" class="wp-alert__form">
        <mark-paid-form :manual-invoice="alert.invoice"></mark-paid-form>
      </div>
    </div>
  </div>
</template>
<script>
import MarkPaidForm from './mark_paid_form.vue';

// The Payments tab's alerts: at the top of a wrestler's page, or inside each
// kid's section on a parent's or coach's page. wrestler_payments.vue builds
// them and reloads once an invoice is marked paid.
export default {
  name: 'payments-alerts',
  components: { MarkPaidForm },
  props: {
    alerts: { type: Array, required: true },
    isAdmin: { type: Boolean, default: false },
  },
  data() {
    return {
      markPaidInvoiceId: null,
    };
  },
  created() {
    this.$notificationManager.on('invoice-paid', this.closeForm);
    this.$notificationManager.on('hide-mark-paid-form', this.closeForm);
  },
  destroyed() {
    this.$notificationManager.off('invoice-paid', this.closeForm);
    this.$notificationManager.off('hide-mark-paid-form', this.closeForm);
  },
  methods: {
    closeForm() {
      this.markPaidInvoiceId = null;
    },
  },
};
</script>
